import ReactDOM from 'react-dom/client';
import React from 'react';
import { TextEditor } from './text-editor';
import { v2Component } from '../..';
import { TenantContext } from '../../context/tenant-context';

export function initTextEditor(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('text-editor-v2');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, initialValue, inputId, ...props } = Object.assign({}, element.dataset) as any;

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <TextEditor initialValue={initialValue} inputId={inputId} {...props} />
            </TenantContext.Provider>,
          ),
        );
        const event = new CustomEvent('change');
        element.dispatchEvent(event);
      };

      bootstrap();
    }
  });
}
